module.exports = __webpack_public_path__ + "img/signal-house-car.52436e93.svg";